export const listingManager = {
  header: {
    title: "Annonces",
    newListingTitle: "Nouvelle annonce",
    reorderExit: "Quitter le mode réorganisation",
    reorder: "Réorganiser les annonces",
    done: "Terminé",
    sort: "Trier",
    searchPlaceholder: "Rechercher…",
    searchClear: "Effacer",
    reorderHint: "Faites glisser pour modifier l'ordre",
  },
  globalBtn: {
    title: "Paramètres globaux",
    sub: "Identité et nouvelles réservations · tout le compte",
  },
  list: {
    of: "sur",
    listingSingular: "annonce",
    listingPlural: "annonces",
    unitSingular: "unité",
    unitPlural: "unités",
    retry: "Réessayer",
    noResults: 'Aucun résultat pour « {query} »',
    viewUnits: "Voir les unités",
    loadingUnits: "Chargement des unités…",
    refuerzaA: "Renfort de {name} : reçoit pour l’instant ses réservations du canal",
    noUnits: "Aucune unité",
    dragToMove: "Faites glisser pour déplacer",
    unitFallback: "Unité {n}",
  },
  empty: {
    title: "Sélectionnez une annonce",
    sub: "Choisissez une annonce dans le panneau de gauche pour gérer ses paramètres.",
  },
  create: {
    title: "Nouvelle annonce",
    subtitle: "Créez une annonce pour regrouper vos unités.",
    nameLabel: "Nom de l'annonce",
    namePlaceholder: "Ex. Loft du centre-ville",
    typeLabel: "Type de logement",
    currencyLabel: "Devise",
    currencyHint: "La devise ne peut pas être modifiée après la création de l'annonce.",
    submit: "Créer l'annonce",
    nameRequired: "Le nom est requis.",
    errorCreate: "Impossible de créer l'annonce.",
    successCreate: "Annonce créée avec succès.",
  },
  delete: {
    titleListing: "Supprimer l'annonce",
    titleUnit: "Supprimer l'unité",
    text: "Elle sera supprimée de WACheckin. Ces modifications sont irréversibles. Pour confirmer, saisissez le nom :",
    placeholderListing: "Nom de l'annonce",
    placeholderUnit: "Nom de l'unité",
    deleting: "Suppression…",
    confirm: "Supprimer",
    errorDelete: "Impossible de supprimer.",
    successListing: "Annonce supprimée avec succès.",
    successUnit: "Unité supprimée avec succès.",
  },
  propertyTypes: {
    apartment: "Appartement",
    villa: "Villa",
    hotel: "Hôtel",
    camping: "Camping",
  },
  propertyTypeLabels: {
    apartment: "Appartement",
    house: "Maison",
    villa: "Villa",
    hotel: "Hôtel",
    room: "Chambre",
    studio: "Studio",
    fallback: "Logement",
  },
  toast: {
    errorLoad: "Erreur lors du chargement des annonces.",
    orderSaved: "Ordre enregistré avec succès.",
    errorOrder: "Impossible d'enregistrer l'ordre.",
    nameUpdated: "Nom mis à jour.",
    errorName: "Impossible de mettre à jour le nom.",
  },
  common: {
    cancel: "Annuler",
  },
  globalConfig: {
    hero: {
      title: "Paramètres globaux",
      subPre: "Paramètres de l'agent IA qui s'appliquent à",
      subStrong: "tous vos logements",
      subPost: ".",
    },
    waba: {
      checking: "Vérification de la connexion…",
      connected: "Connecté",
      start: "Commencez ici",
      titleConnected: "WhatsApp Business",
      titleDisconnected: "Connecter WhatsApp Business",
      checkingSub: "Vérification du statut de votre numéro…",
      numberPrefix: "Numéro",
      verified: "vérifié et prêt à envoyer ✓",
      pending: "en attente de vérification",
      linked: "Votre compte WhatsApp Business est lié.",
      linkPrompt: "Liez votre numéro pour que l'agent puisse répondre à vos voyageurs et leur écrire sur WhatsApp.",
      manage: "Gérer",
      connect: "Connecter",
    },
    sectionLabel: "Général · tout le compte",
    badgeDefault: "IA ✨",
    requiresWaba: "Nécessite une connexion WhatsApp Business",
    notContracted: "Non inclus dans votre forfait. Écrivez-nous pour l'activer.",
    cards: {
      general: {
        title: "Paramètres généraux",
        sub: "Identité et style de l'agent",
      },
      newBookings: {
        title: "Nouvelles réservations",
        sub: "Premier contact, questions et lien de réservation",
      },
      voiceAgent: {
        title: "Agent IA vocal",
        sub: "Répond aux appels téléphoniques",
        badge: "NOUVEAU",
      },
    },
    foot: {
      pre: "Ces paramètres sont",
      strong: "propres à votre compte",
      post: " : les modifier ici les applique automatiquement à toutes les annonces. Le reste de la configuration (check-in, accès, tarification…) reste propre à chaque annonce.",
    },
  },
};
